type ToastErrorContentProps = {
  message: string;
  errors: string[];
};

const ToastErrorContent = ({ message, errors }: ToastErrorContentProps) => {
  return (
    <>
      {message}:
      <br />
      <div>
        {errors.map((error: string) => (
          <p key={error}>{error}</p>
        ))}
      </div>
    </>
  );
};

export default ToastErrorContent;
export { ToastErrorContent };
